export const LINK_KINDS = {
    Standard: 'standard',
    Subtle: 'subtle',
};
